import { render, staticRenderFns } from "./PropertyCustomerEmptyNew.vue?vue&type=template&id=6cde1182&scoped=true&lang=pug&"
import script from "./PropertyCustomerEmptyNew.vue?vue&type=script&lang=js&"
export * from "./PropertyCustomerEmptyNew.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCustomerEmptyNew.vue?vue&type=style&index=0&id=6cde1182&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde1182",
  null
  
)

export default component.exports